'use client'

// imports
import Image from 'next/image';

// lib files
import { ProfileData } from "@/lib/types/api/profile-data";

// svgs
import PassportCompass from '@/public/svg/compass-rose.svg';

// styles
import styles from './UserImageInitial.module.scss';

interface UserImageInitialProps {
  profile: ProfileData;
  className?: string;
}

const UserImageInitial = (props: UserImageInitialProps) => {
  const {
    profile,
    className,
  } = props;

  const { personal_data, profile: profileData } = profile;

  const isPassport = personal_data?.is_passport ?? false;
  const profileImage = profileData?.thumbnail_url ?? '';
  const userInitial = profileData?.first_name?.[0] ?? '';

  const classes = `${styles.user} ${className ? className : ''}`;

  return (
    <div className={classes}>
      { profileImage ?
        <Image
          alt={profileData.first_name}
          src={profileImage}
          className={styles.profile_icon}
          width={64}
          height={64}
        />
      :
        <span className={styles.profile_initial_thumbnail}>{userInitial}</span>
      }

      { isPassport  && (
        <PassportCompass className={styles.profile_passport_compass} />
      )}
    </div>
  );
};

export default UserImageInitial;
